<section class="py-3 card balance-accounts-section card-div">
  <div class="container-fluid d-flex flex-column h-100">

    <div class="sticky-top-container">
      <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-5 d-flex flex-column align-items-start header-left">
          <div class="sku-badge px-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">Balance Accounts</h2>
          </div>
          <span class="footer-text text-muted small">
            {{ highlights.accounts }} {{ highlights.accounts === 1 ? 'Account' : 'Accounts' }}
          </span>
        </div>

        <div class="col-12 col-md-7 d-flex align-items-center gap-2 justify-content-start justify-content-md-end flex-wrap header-right">
          <button class="btn add-btn py-2 px-3 d-flex align-items-center gap-2" (click)="openAddAccountModal()">
            <fa-icon [icon]="faPlus" class="icon-sm"></fa-icon>
            <span class="fw-bold">Add Balance Account</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row g-3 flex-grow-1" style="min-height: 0;">
      
      <div class="col-12 col-md-9 order-md-1 order-2 d-flex flex-column h-100" style="min-height: 0;">
        
        <div class="filter-card bg-white mb-4">
          <div class="d-flex align-items-center justify-content-between gap-3">
            <div class="search-input-wrapper position-relative flex-grow-1">
              <input type="text" class="form-control filter-search" placeholder="Search by name or last 4 digits..."
                [value]="filters.searchTerm" #searchVal (input)="onSearchInput(searchVal.value)">
              <fa-icon [icon]="faSearch"
                class="position-absolute start-0 top-50 translate-middle-y ms-3 search-icon text-muted"></fa-icon>
            </div>
            
            <div class="active-heading fw-semibold">
              Active
            </div>
          </div>
        </div>

        <div class="flex-grow-1 table-box-wrapper" style="min-height: 0;">
          <div class="card rounded-4 thick-border-gray shadow-none h-100">
            <div class="table-responsive h-100">
              <table class="table custom-table align-middle m-0">
                <thead>
                  <tr>
                    <th class="fw-semibold">Account</th>
                    <th class="fw-semibold text-center">Account number</th>
                    <th class="fw-semibold text-center">Balance</th>
                    <th class="fw-semibold text-center">Status</th>
                    <th class="fw-semibold text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of accountList; track item._id) {
                  <tr class="normal-row cursor-pointer" (click)="navigateToTransfers(item)">
                    <td class="account-name fw-sm-bold">
                      {{ item.accountName }}
                    </td>
                    <td class="text-center">
                      <span class="account-ref-badge" [ngStyle]="{ 'background-color': item.badgeColor + '22', 'color': item.badgeColor }">
                        @if(item.accountNumber) { xxx{{item.accountNumber}} } @else { - }
                      </span>
                    </td>
                    <td class="text-center account-balance fw-bold">
                      ₹{{ (item.amount || 0) | number : '1.0-0' : 'en-IN' }}
                    </td>
                    <td class="text-center status-cell">
                      <span class="status-label fw-sm-bold" [ngClass]="item.status === 'Active' ? 'text-green' : 'text-red'">
                        {{ item.status || '-' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <a class="btn app-btn-primary btn-sm" (click)="navigateToTransfers(item); $event.stopPropagation()">
                        <fa-icon [icon]="faEye" data-bs-toggle="tooltip" ngbTooltip="View details" [placement]="'top'"></fa-icon>
                      </a>
                    </td>
                  </tr>
                  }

                  @if (loader) {
                  <tr>
                    <td colspan="5" class="text-center py-4">
                      <app-loader [loadingIcon]="loader"></app-loader>
                    </td>
                  </tr>
                  }

                  @if (!loader && errorMessage) {
                  <tr>
                    <td colspan="5" class="text-center py-5 text-danger small fw-semibold">
                      Failed to load accounts: {{ errorMessage }}
                    </td>
                  </tr>
                  }

                  @if (!loader && !errorMessage && accountList.length === 0) {
                  <tr>
                    <td colspan="5" class="text-center py-5 text-muted small">
                      No accounts found.
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="col-12 col-md-3 order-md-2 order-1">
        <div class="row g-3">
          
          <div class="col-12 col-sm-6 col-md-12">
            <div class="balance-highlight-card h-100 bg-white">
              <div class="card-top-label">Total accounts</div>
              <div class="card-value py-1">{{ highlights.accounts }}</div>
              <div class="card-footer-label">Active</div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-12">
            <div class="balance-highlight-card h-100 bg-white">
              <div class="card-top-label">Total balance</div>
              <div class="card-value py-1">₹{{ highlights.balance | shortNumber }}</div>
              <div class="card-footer-label">Across {{ highlights.accounts }} {{ highlights.accounts === 1 ? 'account' : 'accounts' }}</div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</section>
